import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Clone the request to add the new header

    req = req.clone({
      setHeaders: {
        'X-Api-Key': environment.REST_CONFIG.API_SUBSCRIPTION_KEY,
        'Hera-Subscription-Key': environment.REST_CONFIG.API_SUBSCRIPTION_KEY,
      },
    });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(req);
  }
}
